import React, { useState, useEffect } from "react";
import "../../../../../src/components/dashboardcomponents/TeamComponents/TeamEditProfile/style.css";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MultiInputTimeRangeField } from "@mui/x-date-pickers-pro/MultiInputTimeRangeField";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactComponent as Close } from "../../../../assets/images/remove.svg";
import { CoUserWorkingApi } from "../../../../store/features/addUserWorkingHours";
import dayjs from "dayjs";
import { ReactComponent as Cancel } from "../../../../assets/images/TicketImages/cancel.svg";

function AvalibityProfile({ workingData, userID }) {
  const [selectedDays, setSelectedDays] = useState([]);
  const [isChecked, setIsChecked] = useState({});
  const [selectedTimes, setSelectedTimes] = useState({});
  const [loading, setLoading] = useState(false);
  const [touchedFields, setTouchedFields] = useState({});
  const dispatch = useDispatch();
  const userId = userID ?? useParams().userId;

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  console.log('workingData', workingData);

  useEffect(() => {
    if (workingData && workingData.length > 0) {
      const initialSelectedTimes = {};
      const initialChecked = {};

      // Group data by day to handle duplicates (take the last entry for each day)
      const groupedData = {};
      workingData.forEach((dayData) => {
        groupedData[dayData.day] = dayData;
      });

      Object.values(groupedData).forEach((dayData) => {
        // Only set times if they're not "00:00" (meaning they have actual values)
        const hasValidTimes = dayData.start_time !== "00:00" || dayData.end_time !== "00:00";

        if (hasValidTimes) {
          initialSelectedTimes[dayData.day] = {
            start_time: dayData.start_time || "00:00",
            end_time: dayData.end_time || "00:00",
          };
        }

        initialChecked[dayData.day] = dayData.is_available === true;
      });

      setSelectedTimes(initialSelectedTimes);
      setSelectedDays(Object.keys(groupedData).filter(day => groupedData[day].is_available));
      setIsChecked(initialChecked);
    }
  }, [workingData]);

  const handleCheckboxChange = (day) => {
    setSelectedDays((prevSelectedDays) => {
      const updatedSelectedDays = [...prevSelectedDays];
      const index = updatedSelectedDays.indexOf(day);

      if (index === -1) {
        updatedSelectedDays.push(day);
      } else {
        updatedSelectedDays.splice(index, 1);
      }

      return updatedSelectedDays;
    });

    setIsChecked((prevIsChecked) => ({
      ...prevIsChecked,
      [day]: !prevIsChecked[day],
    }));
  };

  const handleTimeChange = (time, position, day) => {
    const [start, end] = time;
    const formattedStart = start ? start.format("HH:mm") : null;
    const formattedEnd = end ? end.format("HH:mm") : null;

    setSelectedTimes((prev) => ({
      ...prev,
      [day]: {
        ...prev[day],
        start_time: formattedStart,
        end_time: formattedEnd,
      },
    }));
    setTouchedFields((prev) => ({
      ...prev,
      [day]: true,  // mark this day as touched
    }));
  };

  const validateWorkingHours = () => {
    for (const day of days) {
      const times = selectedTimes[day];
      if (times) {
        const { start_time, end_time } = times;

        // Only validate if either start or end is not "00:00"
        if ((start_time && start_time !== "00:00") || (end_time && end_time !== "00:00")) {
          if (!start_time || !end_time || start_time === "00:00" || end_time === "00:00") {
            toast.error(`${day}: Please enter both start and end time`);
            return false; // stop on first invalid
          }
        }
      }
    }
    return true;
  };

  const addWorkingHoursHandler = async () => {
    if (!validateWorkingHours()) return; // 
    const selectedDaysData = days.map((day) => ({
      day_of_week: day,
      start_time: selectedTimes[day]?.start_time || "00:00",
      end_time: selectedTimes[day]?.end_time || "00:00",
      is_available: !!isChecked[day],
    }));
    console.log('Selected Days Data:', selectedDaysData);

    const daysData = [...selectedDaysData];

    setLoading(true);
    const UserWorkingHour = dispatch(
      CoUserWorkingApi({
        id: userId,
        requestHeaders: {
          workingHoursArray: daysData,
        },
      })
    );

    try {
      const data = await UserWorkingHour;

      if (typeof data.payload === "undefined") {
        toast.error("Some Error Occurred. Please try again later.");
      } else if (data.payload.status === 201) {
        toast.success(data.payload.message);
      } else if (data?.payload?.status === 400) {
        toast.error(data.payload.message);
      } else if (data?.payload?.status === 500) {
        toast.error("Some Error Occurred. Please try again later.");
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
      setTouchedFields({}); // Reset touched fields after save
    }
  };

  const handleReset = () => {
    setSelectedDays([]);
    setIsChecked({});
    setSelectedTimes({});
  };

  const handleClearTime = (day) => {
    setSelectedTimes((prev) => {
      const newTimes = { ...prev };
      delete newTimes[day]; // Remove the day completely
      return newTimes;
    });
  };

  // Helper function to get display value for time field
  const getTimeDisplayValue = (day, timeType) => {
    const dayTimes = selectedTimes[day];
    if (!dayTimes) return null;

    const timeValue = timeType === 'start' ? dayTimes.start_time : dayTimes.end_time;
    if (!timeValue || timeValue === "00:00") return null;

    // Parse the time correctly and set it to today's date to avoid timezone issues
    const today = dayjs();
    const [hours, minutes] = timeValue.split(':');
    return today.hour(parseInt(hours)).minute(parseInt(minutes)).second(0);
  };

  const saveButtonDisabled = !Object.keys(touchedFields).length || loading;

  return (
    <>
      <div style={{ width: userID ? '100%' : '50%' }} className="Aavaliable-Main-Container001">
        {days.map((day, index) => (
          <div key={index} className="Avaliable-Main-Container" style={{
            height: '40px',

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '8px',

          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',

            }} className="Avaliable-Checkbox-main">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  style={{ bottom: '10px' }}
                  type="checkbox"
                  className="custom-checkbox"
                  id={`UniqueCheckbox${index}`}
                  checked={!!isChecked[day]}
                  onChange={() => handleCheckboxChange(day)}
                />
                <label style={{ bottom: '10px' }} htmlFor={`UniqueCheckbox${index}`} />
              </div>
              <span style={{
                textTransform: "capitalize",
                fontSize: '14px',
                color: '#405261',
                lineHeight: '20px',
                marginBottom: '-1px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: '400',
                minWidth: '80px'
              }}>
                {day}
              </span>
            </div>
            <div className="Avaliable-button-container" style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px'
            }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "MultiInputTimeRangeField",
                    "SingleInputTimeRangeField",
                  ]}
                  sx={{
                    height: '40px',
                    padding: 0,
                    margin: 0,
                    '& .MuiStack-root': {
                      margin: 0,
                      padding: 0
                    }
                  }}
                >
                  <div
                    style={{
                      gap: "12px",
                      display: 'flex',
                      alignItems: 'center',
                      margin: 0,
                      padding: 0
                    }}
                  >
                    <MultiInputTimeRangeField
                      slotProps={{
                        textField: ({ position }) => ({
                          label: undefined,
                          placeholder: position === "start" ? "Start time" : "End time",
                          inputProps: {
                            style: {
                              textAlign: "center",
                              height: '24px',
                              padding: '8px 12px'
                            },
                          },
                          sx: {
                            width: '120px',
                            height: '40px',
                            margin: 0,
                            "& .MuiInputBase-root": {
                              height: '40px',
                              padding: 0,

                              border: '1px solid #D1D5DB',
                              borderRadius: '6px',
                              '&:hover': {
                                borderColor: '#9CA3AF'
                              },
                              '&.Mui-focused': {
                                borderColor: '#3B82F6',
                                boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)'
                              }
                            },
                            "& .MuiInputBase-input": {
                              textAlign: "center !important",
                              fontSize: '14px',
                              color: '#405261',
                              lineHeight: '20px',
                              fontFamily: 'Inter, sans-serif',
                              fontWeight: '400',
                              height: '24px',
                              padding: '8px 12px',
                              boxSizing: 'border-box'
                            },
                            "& input::placeholder": {
                              textAlign: "center !important",
                              opacity: 1,
                              fontSize: '14px',
                              color: '#405261',
                              lineHeight: '20px',
                              fontFamily: 'Inter, sans-serif',
                              fontWeight: '400',
                            },
                            "& .MuiOutlinedInput-root": {
                              height: '40px',
                              '& fieldset': {
                                border: 'none'
                              }
                            }
                          },
                        }),
                        separator: {
                          children: <span style={{ display: "none" }}></span> // force hide separator
                        }
                      }}
                      format="h:mm A"
                      ampm={true}
                      value={[
                        getTimeDisplayValue(day, 'start'),
                        getTimeDisplayValue(day, 'end')
                      ]}
                      onChange={(time) => handleTimeChange(time, "end", day)}
                    />
                  </div>
                </DemoContainer>
              </LocalizationProvider>
              {selectedTimes[day] &&
                (selectedTimes[day].start_time !== "00:00" || selectedTimes[day].end_time !== "00:00") ? (
                <button
                  type="button"
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    display: 'flex',
                    alignItems: 'center',
                    padding: '4px 14px 4px 8px',
                    paddingRight: '8px',
                    borderRadius: '4px',
                    paddingLeft: '0px',
                    '&:hover': {
                      backgroundColor: '#F3F4F6'
                    }
                  }}
                  onClick={() => handleClearTime(day)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8 8L16 16" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M16 8L8 16" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              ) : (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '32px',

                }}></div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div style={{
        marginTop: '32px',
        width: userID ? '100%' : '50%',
        marginLeft: userID ? '0' : 'auto',
        marginRight: userID ? '0' : 'auto',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px'
      }} className="Addworking-button-container">
        <button
          className="addworking-reset"
          type="button"
          onClick={handleReset}

        >
          Reset
        </button>
        <button
          className="addworking-save"
          type="button"
          onClick={addWorkingHoursHandler}
          style={{
            border: saveButtonDisabled ? "1px solid #C5CED6" : "#148DFD", // light grey if disabled
            backgroundColor: saveButtonDisabled ? "#F9FAFA" : "#148DFD", // light grey if disabled
            color: saveButtonDisabled ? "#93A1B0" : "#fff",
            cursor: saveButtonDisabled ? "not-allowed" : "pointer",
            pointerEvents: saveButtonDisabled ? "none" : "auto", // optional
          }}
          disabled={!Object.keys(touchedFields).length || loading}
        >
          {loading ? "Loading..." : "Save"}
        </button>
      </div>
    </>
  );
}

export default AvalibityProfile;